import type {
  PrintTemplate,
  PrintTemplateType,
} from "@lemmonhq/types";
import type { PrintTemplateFormState } from "./types";
import { DEFAULT_PRINT_TEMPLATE_TYPE } from "./types";
import defaultKitchenTemplate from "../../../../../../../../packages/business/logic/src/printer/templates/kitchenTicket/templates/default.liquid?raw";
import highDensityKitchenTemplate from "../../../../../../../../packages/business/logic/src/printer/templates/kitchenTicket/templates/high-density.liquid?raw";

export const PRINT_TEMPLATE_QUERY_KEY = ["printTemplates"] as const;
export const PRINT_TEMPLATE_PREVIEW_DEBOUNCE_MS = 400;

export const PRINT_TEMPLATE_PRESETS = [
  {
    id: "default",
    name: "Default kitchen ticket",
    description: "Balanced spacing with larger line items.",
    template: defaultKitchenTemplate,
  },
  {
    id: "high-density",
    name: "High-density kitchen ticket",
    description: "More compact spacing for busy service.",
    template: highDensityKitchenTemplate,
  },
] as const;

export const createDefaultPrintTemplateForm =
  (): PrintTemplateFormState => ({
    name: "",
    type: DEFAULT_PRINT_TEMPLATE_TYPE,
    template: PRINT_TEMPLATE_PRESETS[0].template,
  });

export const printTemplateToFormState = (
  template: PrintTemplate,
): PrintTemplateFormState => ({
  name: template.name,
  type: template.type,
  template: template.template,
});

export const getPrintTemplateTypeLabel = (type: PrintTemplateType) => {
  return type === "tax_receipt" ? "Tax receipt" : "Kitchen ticket";
};

export const getPrintTemplateTypeDescription = (type: PrintTemplateType) => {
  return type === "tax_receipt"
    ? "Customer-facing receipt layout"
    : "Back-of-house kitchen ticket layout";
};

export const validatePrintTemplateForm = (
  form: PrintTemplateFormState,
): string | null => {
  if (!form.name.trim()) {
    return "Enter a template name.";
  }

  if (!form.template.trim()) {
    return "Enter template markup.";
  }

  return null;
};
